import React, { useEffect, useState } from "react";
import { Img } from '@chakra-ui/react'
import { statusReferredType } from "../InformativeLayer.d";
import confetti from 'assets/images/confetti.svg'
import technical_support from 'assets/images/technical-support.svg'
import rocket from 'assets/images/rocket.svg'
import under_construction from 'assets/images/under-construction.svg'


export default function useInformativeLayerImage(status: statusReferredType): React.JSX.Element {
  const [image, setImage] = useState<React.JSX.Element|null>()  

  useEffect(() => {
    switch (status) {
      case 'EXIT':
        setImage ( <Img data-testid='img-confetti' src={confetti} alt='confetti' width='90px' height='90px' /> ) 
        break       
      case 'NOT_EXIT':
        setImage ( <Img data-testid='img-technical_support' src={technical_support} alt='technical support' width='80px' height='80px' /> )
        break
      case 'ERROR':
        setImage ( <Img data-testid='img-under_construction' src={under_construction} alt='under construction' width='80px' height='80px' /> )
        break
      case 'EXPIRED':
        setImage ( <Img data-testid='img-rocket' src={rocket} alt='rocket' width='80px' height='80px' /> )
        break
      case 'LIMIT_EXCEEDED':
        setImage ( <Img data-testid='img-under_construction' src={under_construction} alt='under construction' width='80px' height='80px' /> )
        break
      default:
        setImage ( <></> )    
    }
  },[status])

  return image
}
